<template>
  <b-navbar
    toggleable="lg"
    type="dark"
    variant="navbar"
    :class="navBarIsStickyClass"
  >
    <b-navbar-brand href="https://app.pixapup.com">
      <picture>
        <!-- <source srcset="/assets/logo5-160x60.png" media="(min-width: 992px)">
        <img src="/assets/logo5-80x30.png" />-->
        <!-- <source srcset="https://chiropixels.com/wp-content/uploads/2020/07/logo-v5-inkscape-sized.svg"
        media="(min-width: 992px)">-->
        <img
          class="header-img"
          src="https://pixapup.com/wp-content/uploads/2020/10/main-logo.svg"
        />
      </picture>
    </b-navbar-brand>

    <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

    <b-collapse id="nav-collapse" is-nav>
      <b-navbar-nav class="ml-auto">
        <!-- <b-nav-item to="/login" exact>Test-Login</b-nav-item>
        <b-nav-item to="/upload-image" exact>Test-Upload</b-nav-item>
        <b-nav-item to="/css-sandbox" exact>CSS</b-nav-item>
        <b-nav-item to="/upload-result" exact>UploadResult</b-nav-item> -->

        <b-nav-item to="/sandbox" exact>Sandbox</b-nav-item>
        <b-nav-item to="/" exact>Home</b-nav-item>

        <b-nav-item-dropdown
          v-if="authUser"
          text="Your Images"
          active-class="active"
        >
          <b-dropdown-item
            v-if="authUser"
            to="/upload-image"
            active-class="active"
            @click="rerenderView"
            >Upload New</b-dropdown-item
          >
          <b-dropdown-item
            v-if="authUser"
            to="/images-list-pending"
            active-class="active"
            @click="rerenderView"
            >Uploads</b-dropdown-item
          >
          <b-dropdown-item
            v-if="authUser"
            to="/images-list-selected"
            active-class="active"
            @click="rerenderView"
            >Selected</b-dropdown-item
          >
          <b-dropdown-item
            v-if="authUser"
            to="/images-list-published"
            active-class="active"
            @click="rerenderView"
            >Published</b-dropdown-item
          >
          <b-dropdown-item
            v-if="authUser"
            to="/images-list-unusable"
            active-class="active"
            @click="rerenderView"
            >Unusable</b-dropdown-item
          >
        </b-nav-item-dropdown>

        <b-nav-item-dropdown
          v-if="authUser"
          text="Your Account"
          active-class="active"
        >
          <b-dropdown-item
            v-if="authUser"
            to="/profile"
            active-class="active"
            @click="rerenderView"
            >Profile/Preferences</b-dropdown-item
          >
          <b-dropdown-item
            v-if="authUser"
            to="/change-email"
            active-class="active"
            @click="rerenderView"
            >Change Email</b-dropdown-item
          >
          <b-dropdown-item
            v-if="authUser"
            to="/change-password"
            active-class="active"
            @click="rerenderView"
            >Change Password</b-dropdown-item
          >
          <b-dropdown-item
            v-if="authUser"
            to="/delete-account"
            active-class="active"
            >Delete Account...</b-dropdown-item
          >
        </b-nav-item-dropdown>

        <b-nav-item-dropdown v-if="authUser" text="Help" active-class="active">
          <b-dropdown-item to="/app-overview" active-class="active"
            >App Overview</b-dropdown-item
          >
          <b-dropdown-item to="/image-guidelines" active-class="active"
            >Image Guidelines</b-dropdown-item
          >
          <b-dropdown-item to="/faq" active-class="active">FAQ</b-dropdown-item>
        </b-nav-item-dropdown>

        <b-nav-item v-if="authUser" to="/refer" exact>Refer Friends</b-nav-item>

        <b-nav-item-dropdown text="Resources">
          <b-dropdown-item href="https://pixapup.com" target="_blank"
            >Pixapup.com</b-dropdown-item
          >
          <b-dropdown-item href="https://pixapup.com/privacy" target="_blank"
            >Privacy Policy</b-dropdown-item
          >
          <b-dropdown-item
            href="https://pixapup.com/terms-of-service"
            target="_blank"
            >Terms of Service</b-dropdown-item
          >
        </b-nav-item-dropdown>

        <b-nav-item v-if="authUser" to="/contact" @click="rerenderView"
          >Contact</b-nav-item
        >
        <b-nav-item v-if="authUser" to="/logout">Logout</b-nav-item>
        <b-nav-item v-if="!authUser" to="/signup">Sign Up</b-nav-item>
        <b-nav-item v-if="!authUser" to="/login">Login</b-nav-item>
      </b-navbar-nav>
    </b-collapse>
  </b-navbar>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  data() {
    return {
      //   authUser: null
    };
  },
  computed: {
    ...mapGetters('auth', ['authUser']),
    ...mapGetters('layout', ['navBarSticky']),

    navBarIsStickyClass: function () {
      var classObj = {};
      if (this.navBarSticky) {
        classObj['nav-bar--sticky'] = true;
      }
      return classObj;
    },

    // **WITHOUT** ...mapGetters('auth',['authUser']) :
    //    This gives console warning/error: Computed property "authUser" was assigned to but it has no setter.
    //    >> G: vue js computed property was assigned to but it has no setter ... first result stackoverflow - excellent
    //      https://stackoverflow.com/questions/46106037/vuex-computed-property-name-was-assigned-to-but-it-has-no-setter
    // authUser: function() {
    //   return this.$store.getters["auth/authUser"];
    // }
    // authUser: {
    //   get: function () {
    //     return this.$store.getters['auth/authUser'];
    //   },
    //   set: function (user) {
    //     return user;
    //   },
    // },
  },
  methods: {
    rerenderView: function () {
      this.$parent.rerenderView();
    },
    // Changed logout nav link to /logout route as opposed to click handler...
    // so, this logout method not needed here anymore...
    // logout: async function () {
    //   // Detach all FB document listeners
    //   var docListeners = this.$store.getters.docListeners;
    //   Object.values(docListeners).forEach((f) => f());
    //   await this.$fapi.logout();
    //   if (this.$fapi.error) {
    //     this.$store.dispatch('setErrorMsg', this.$fapi.error);
    //     this.$router.push('/alert');
    //   } else {
    //     this.$store.dispatch('uploadTracker/clearImageCounts');
    //     this.$store.dispatch('uploadTracker/clearImageNamesAll');
    //     this.$store.dispatch('setLastAction', 'logout');
    //     // Redirect to login page with 'goodbye' message displayed above the login form.
    //     this.$router.push('/login');
    //   }
    // },
  },
  created() {
    //   // this.authUser = this.$store.getters['auth/authUser'];
    //   // console.log(this.$store.getters["auth/authUser"]);
  },
};
</script>

<style>
.router-link-active {
  color: #1aec79 !important;
}
.dropdown-menu {
  /* margin: 0 !important; */
  padding: 0 !important;
  background-color: black !important;
}
.dropdown-item {
  font-size: 1rem;
  color: white !important;
}
.dropdown-item:hover {
  background-color: black !important;
  color: #22b422 !important;
}

.header-img {
  width: 130px;
}

@media (min-width: 992px) {
  .header-img {
    width: 160px;
  }
}

/* nav.navbar {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
} */
</style>